import { Injectable } from '@angular/core';
// import * as moment from 'moment';
import * as moment from 'moment-timezone';

@Injectable({
  providedIn: 'root',
})
export class MomentService {
  timeZone;
  constructor() {
    this.timeZone = moment.tz.guess();
    moment.tz.setDefault(this.timeZone);
  }

  //To get current date only with/without given format
  getCurrentDateOnly(format = '') {
    if (format == '') {
      return moment().format('YYYY-MM-DD');
    } else {
      return moment().format(format);
    }
  }

  //To get today full date
  getCurrentFullDate(date = '') {
    if (date != '' && date != null && date != undefined) {
      return moment(date);
    } else {
      return moment();
    }
  }

  //To get database date time format
  getDBDateTimeFormat(date = '') {
    if (date != '' && date != null && date != undefined) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    } else {
      return moment().format('YYYY-MM-DD HH:mm:ss');
    }
  }
  //To get database date time format
  getRelativeTime(date = '') {
    if (date != '' && date != null && date != undefined) {
      return moment(date).fromNow();
    } else {
      return moment().format('YYYY-MM-DD HH:mm:ss');
    }
  }

  //get date with defined formate
  getDateWithFormat(date, format) {
    if (date != '' && date != null && format != '') {
      return moment(date).tz(this.timeZone).format(format);
    }
  }

  //To get database date format
  getDBDateFormat(date = '') {
    if (date != '' && date != null && date != undefined) {
      return moment(date).format('YYYY-MM-DD');
    } else {
      return moment().format('YYYY-MM-DD');
    }
  }

  //get genearal US date with format
  getGeneralDateFormat(date = '', format = 'MM/DD/YYYY') {
    if (date != '' && date != null && date != undefined && date != '0000-00-00') {
      return moment(date).format(format);
    } else {
      return moment().format(format);
    }
  }

  getGeneralDateMedFormat(date = '') {
    if (date != '' && date != null && date != undefined && date != '0000-00-00') {
      return moment(date).format('MM/DD/YY');
    } else {
      return moment().format('MM/DD/YY');
    }
  }

  determineLatestDate(date1, date2) {
    if (date1 && date2) {
      if (moment(date1).isSameOrAfter(date2)) {
        return date1;
      }
      return date2;
    }
    return date1 ? date1 : date2;
  }

  getCurrentDate(format: string = 'YYYY-MM-DD') {
    return moment().format(format);
  }

  getPastDate(timeAmount, timeIncrement, format: string = 'YYYY-MM-DD') {
    return moment().subtract(timeAmount, timeIncrement).format(format);
  }

  formateDate(date: string, format: string = 'MM/DD/YYYY') {
    var isIso = moment(date, moment.ISO_8601, true).isValid();
    if (isIso) return moment.utc(date).format(format);
    return moment(date).format(format);
  }
}
